export default __webpack_public_path__ + "static/media/expert.3984a2d3.png";